<template>
  <div>
    <!-- 桌面端视图 -->
    <div class="desktop-view">
      <DesktopPage />
    </div>
    
    <!-- 移动端视图 -->
    <div class="mobile-view">
      <MobilePage />
    </div>
  </div>
</template>
<script>
import DesktopPage from '../desktopPage/index.vue'
import MobilePage from '../mobilePage/index.vue'
export default {
  components: { DesktopPage, MobilePage },
}
</script>
<style scoped>
.desktop-view { display: block; }
.mobile-view { display: none; }

/* 当屏幕宽度小于768px时切换为移动端 */
@media (max-width: 768px) {
  .desktop-view { display: none; }
  .mobile-view { display: block; }
}
</style>